export default class ActionEvent
{
  constructor()
  {

  }

  trigger(context)
  {

  }
}
